import listActions from 'src/modules/monthlyReports/list/monthlyReportsListActions';
import MonthlyReportsService from 'src/modules/monthlyReports/monthlyReportsService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'MONTHLYREPORTS_DESTROY';

const monthlyReportsDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: monthlyReportsDestroyActions.DESTROY_STARTED,
      });

      await MonthlyReportsService.destroyAll([id]);

      dispatch({
        type: monthlyReportsDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.monthlyReports.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/monthly-reports');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: monthlyReportsDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: monthlyReportsDestroyActions.DESTROY_ALL_STARTED,
      });

      await MonthlyReportsService.destroyAll(ids);

      dispatch({
        type: monthlyReportsDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.monthlyReports.destroyAll.success'),
      );

      getHistory().push('/monthly-reports');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: monthlyReportsDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default monthlyReportsDestroyActions;
